import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRole } from '../enum/auth-role.enum';
import { AuthAccount } from '../models/auth-account';
import { StorageParameters, StorageService } from './storage.service';
import * as Sentry from '@sentry/angular-ivy';
import { CurrentFoundationService } from './current-foundation.service';
import { AgreementAcceptanceService } from './agreement-acceptance.service';
import { AnalyticsService } from '../../analytics/analytics.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user?: AuthAccount;

  constructor(
    private storage: StorageService,
    private router: Router,
    private currentFoundationService: CurrentFoundationService,
    private agreementAcceptanceService: AgreementAcceptanceService,
    private analyticsService: AnalyticsService
  ) {}

  setUser(user: AuthAccount) {
    if (this.user?.loginId == user.loginId) return;
    this.user = user;
    this.storage.setItem(StorageParameters.userId, user.loginId);
    this.storage.setItem(StorageParameters.userRole, user.roles);
    this.storage.setItem(StorageParameters.userEmail, user.loginEmail);
    Sentry.setUser({
      email: user.email,
      id: String(user.loginId),
    });
    this.analyticsService.setUser(user);
  }

  getUser() {
    return this.user;
  }

  isDashUser() {
    return this.user?.roles.includes(AuthRole.Dash);
  }

  isPartnerUser() {
    return this.user?.roles.includes(AuthRole.Partner);
  }

  isFoundationMember() {
    return (
      this.user?.roles.includes(AuthRole.FoundationMember) ||
      this.user?.roles.includes(AuthRole.Foundation)
    );
  }

  getUserFoundation() {
    return this.user?.foundationId ?? '0';
  }

  logout() {
    this.storage.clearItems();
    this.user = undefined;
    this.currentFoundationService.clearData();
    Sentry.setUser(null);
    this.agreementAcceptanceService.invalidatePending();
    this.router.navigate(['sign']);
  }
}
